import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CommonRoutes from '../../routes/CommonRoutes';

import { StyledProvider } from '../../vNext/theme';
import lazy from '../../util/lazyLoading';

const VNextHomeScreen = lazy(() => import('../../vNext/pages/HomePage/HomePage'));
const VNextSubscriptionScreen = lazy(() => import('../../vNext/pages/SubscriptionPage/SubscriptionPage'));

const BrandRoutes = () => {
    const { publication } = CONFIG.myPage;
    const paths = CONFIG.subPagesPaths;

    return (
        <Routes>
            <Route
                path="/"
                element={ (
                    <StyledProvider publicationID={ publication }>
                        <VNextHomeScreen />
                    </StyledProvider>
                ) }
            />
            <Route
                path={ paths.subscriptionSingle }
                element={ (
                    <StyledProvider publicationID={ publication }>
                        <VNextSubscriptionScreen />
                    </StyledProvider>
                ) }
            />
            <Route
                path="*"
                element={ <CommonRoutes /> }
            />
        </Routes>
    );
};

export default () => (
    <Routes>
        <Route
            path={ `${CONFIG.basePath}/*` }
            element={ <BrandRoutes /> }
        />
        <Route
            path="*"
            element={ <CommonRoutes /> }
        />
    </Routes>
);
